import {
    AfterViewInit,
    ComponentRef,
    Directive,
    ElementRef,
    HostBinding,
    Input,
    OnInit,
    ViewContainerRef,
} from '@angular/core';
import { SelectedAccountStore } from '@core/stores/selected-account-store.service';
import { AdminWrapperComponent } from '@app/shared/components/admin-wrapper/admin-wrapper.component';

@Directive({
    selector: '[enableAdminOnly]',
    standalone: false,
})
export class EnableAdminOnlyDirective implements AfterViewInit, OnInit {
    @Input('enableAdminOnly') shouldDisable: boolean;
    @HostBinding('class.user-disabled') disableElement = false;

    private componentRef: ComponentRef<AdminWrapperComponent>;
    private readonly isAdmin: boolean;

    constructor(
        private elementRef: ElementRef,
        private viewContainerRef: ViewContainerRef,
        private selectedAccountStore: SelectedAccountStore
    ) {
        this.isAdmin = this.selectedAccountStore.selectedAccount.isAdmin();
    }

    ngOnInit() {
        this.disableElement = !this.isAdmin && this.shouldDisable;
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.elementRef && !this.isAdmin) {
                this.componentRef =
                    this.viewContainerRef.createComponent<AdminWrapperComponent>(
                        AdminWrapperComponent
                    );
                this.componentRef.instance.element = this.elementRef;
                this.componentRef.instance.showTooltip = this.disableElement;
            }
        }, 0);
    }
}
